<template>
  <div class="modal fade" id="ownerCreateModal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="card-header">
          <h3 class="card-title">{{ $t('label.owner_information') }}</h3>
          <div class="card-tools">
            <button type="button" class="btn btn-tool" data-dismiss="modal" aria-label="Close" :title="$t('label.close')">
              <fa :icon="fas.faTimes" style="color: red;" id="icon-close"/>
            </button>
          </div>
        </div>
        <div class="modal-body">
          <owner :isCreateOwner="true" :isModal="true"></owner>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fas } from "@fortawesome/free-solid-svg-icons";
export default {
  name: "createModal",
  computed: {
    fas() {
      return fas;
    }
  }
}
</script>
<style lang="scss" scoped>
  #icon-close{
    margin-top: -10px !important;
  }
</style>